import { render, staticRenderFns } from "./SupplierTransports.vue?vue&type=template&id=9e438fe4&scoped=true&"
import script from "./SupplierTransports.vue?vue&type=script&lang=js&"
export * from "./SupplierTransports.vue?vue&type=script&lang=js&"
import style0 from "./SupplierTransports.vue?vue&type=style&index=0&id=9e438fe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e438fe4",
  null
  
)

export default component.exports